import constants from "constants";

const {
  LOGIN_SAGA,
  LOGOUT_SAGA,
  PERFORM_LOGOUT,
  UNSUBSCRIBE_SAGA,
  FORGOT_PASSWORD_SAGA,
  NEW_PASSWORD_SAGA,
  CHANGE_PASSWORD_SAGA,
  SEND_CONFIRM_CODE,
  ADMIN_CONFIRM_LOGIN,
  ADMIN_RESEND_CONFIRM_CODE,
} = constants;

const performLogout = () => {
  return {
    type: PERFORM_LOGOUT,
  };
};

const logout = () => ({
  type: LOGOUT_SAGA,
});

const login = (email, password, redirect) => {
  return {
    type: LOGIN_SAGA,
    email,
    password,
    redirect,
  };
};

const sendConfirmationCode = (payload) => ({
  type: SEND_CONFIRM_CODE,
  payload,
});

const adminConfirmLogin = (payload) => ({
  type: ADMIN_CONFIRM_LOGIN,
  payload,
});

const adminResendConfirmCode = (payload) => ({
  type: ADMIN_RESEND_CONFIRM_CODE,
  payload,
});

const forgotPasswordSaga = (email) => ({
  type: FORGOT_PASSWORD_SAGA,
  email,
});

const unsubscribeSaga = (token) => ({
  type: UNSUBSCRIBE_SAGA,
  token,
});

const newPasswordSaga = (user) => ({
  type: NEW_PASSWORD_SAGA,
  user,
});

const changePasswordSaga = (user) => ({
  type: CHANGE_PASSWORD_SAGA,
  user,
});

export {
  login,
  logout,
  performLogout,
  forgotPasswordSaga,
  unsubscribeSaga,
  newPasswordSaga,
  changePasswordSaga,
  sendConfirmationCode,
  adminConfirmLogin,
  adminResendConfirmCode,
};



// WEBPACK FOOTER //
// ./src/actions/auth.js